import Movie from '../../../src/images/Movie1.jpg'
import Calculator from '../../../src/images/Calculator.png'
import Christvineyard from '../../../src/images/Christvineyard.png'
import Candino from '../../../src/images/Candino.png'
import HFDI from '../../../src/images/HFDI.png'
import Todolist from '../../../src/images/Todolist.png'
import Nodeblog from '../../../src/images/Nodeblog.png'
import Weatherapp from '../../../src/images/Weatherapp.png'

export default [
    {
        name: 'Movie App',
        file: Movie,
        linkTo:'https://jumbomovieapp.netlify.app/'
    },
    {
        name: 'Basic Vanilla JS Calculator',
        file: Calculator,
        linkTo: 'https://basecalculator.netlify.app/javascript-calculator-master/'

    },
    {
        name: 'Christ Vineyard Ministries',
        file: Christvineyard,
        linkTo:'http://christvineyardministries.org.ng/'
    },
    {
        name: 'Candino West Africa LTD',
        file: Candino,
        linkTo:'http://candinowestafrica.com.ng/'
    },
    {
        name: 'HFDI Global Consulting Firm',
        file: HFDI,
        linkTo:'http://www.hfdiglobalconsulting.com/'
    },
    {
        name: 'Vanilla JS Todolist',
        file: Todolist,
        linkTo: 'https://jolly-pasteur-8ad199.netlify.app/'
    },
    {
        name: 'Express, Node JS Blog',
        file: Nodeblog,
        linkTo: 'https://github.com/JumboDaniel/node-blog-project'
    },
    {
        name: ' Vanilla JS Weatherapp ',
        file: Weatherapp,
        linkTo: 'https://github.com/JumboDaniel/Weather-app'
    }
]